import styled, { css } from 'styled-components';

interface Props {
  hasBorder?: boolean;
}

const Spacer = ({ hasBorder = false }: Props) => {
  return <StyledDiv $hasBorder={hasBorder}></StyledDiv>;
};

const StyledDiv = styled(({ ...rest }) => <div {...rest} />)`
  height: ${props => props.theme.spacing(2)};

  ${props =>
    props.$hasBorder
      ? css`
          margin-top: ${props => props.theme.spacing(2)};
          border-top: 1px solid ${props => props.theme.palette.grey[300]};
        `
      : null}
`;

export default Spacer;
